export const DATA_ABOUT = {
    Logo1Url: "assets/img/logo/logo-ipb-light.png",
    Logo2Url: "assets/img/logo/logo-ipb-dark.jpg",
    Descricao: "Desde 2004 desenvolvendo as melhores soluções para o campo para o pequeno e médio agricultor",
    Fone: "+55 (55) 9 9917-7070",
    Email: "ipbadm@ipb.agr.br",
    Horarios: "Seg - Sex 8:00 - 18:00, Domingo - FECHADO",
    Contato: {
        Pais: "Brasil",
        Cidade: "Cerro Largo",
        UF: "RS",
        Endereco: "Rua Jacob Reinaldo Haupenthal",
        Numero: "1405",
        Bairro: "Centro",
    }, 
    Links: [
        { Nome: "Home", Url: "/" },
        { Nome: "Sobre", Url: "/#/sobre" },
        { Nome: "Produtos", Url: "/#/produtos" },
        { Nome: "Contato", Url: "/#/contato" },
    ],
    ImagensRodape: [
        { Url: "assets/img/about/cartao_bndes.png" },
        { Url: "assets/img/about/mais-alimentos.png" }
    ],
    SocialLinks: {
        WhatsApp: { Url: "https://api.whatsapp.com/send?l=pt-BR&phone=5555999177070&text=Ola.%20Gostaria%20de%20conversar%20sobre%20produtos%20que%20vi%20no%20site."},
        Facebook: { Url: "https://www.facebook.com/IPBagro1/" },
        Instagram: { Url: "https://www.instagram.com/ipbadm/" },
        Google: { Url: "https://www.google.com/maps/place/IPB+Agro+LTDA/@-28.1433808,-54.7468632,15z/data=!4m5!3m4!1s0x0:0x209691db3ef6897a!8m2!3d-28.1433808!4d-54.7468632" }
    },
    CountDown: [
        { Nome: "Clientes",  Qtd: 1337 },
        { Nome: "Colaboradores",  Qtd: 70 },
        { Nome: "Produtos",  Qtd: 55 }
    ]
}



